import { FC } from 'react'
import styled, { css } from 'styled-components'

const ExamTabTooltipMobile: FC = () => {
  return (
    <StyledWrapper role="tooltip">
      <p className="tooltip-text">가장 빠른 답안 공개!</p>
    </StyledWrapper>
  )
}

export default ExamTabTooltipMobile

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 112px;
    height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 95%;
    left: 25%;
    transform: translateX(-50%);

    background-color: #f4fbff;
    border: 2px solid ${theme.color.primary_2} !important;
    border-radius: 18px;
    box-shadow: 0 2px 4px rgba(2, 2, 2, 0.1);

    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: 90%;
      transform: translateX(-50%) rotate(45deg);
      width: 7px;
      height: 7px;
      background-color: #f4fbff;
      border-top: 2px solid ${theme.color.primary_2} !important;
      border-left: 2px solid ${theme.color.primary_2} !important;
      z-index: -1;
    }

    > .tooltip-text {
      font-size: 12px;
      font-weight: bold;
      white-space: nowrap;
      color: ${theme.color.primary_2};
      line-height: 1.87;
      letter-spacing: -0.6px;
    }
  `}
`
